import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import UserService from "apiService/permissions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useCreatePermission = (setShowAddForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.CREATE_PERMISSION],
    (data) => UserService.createPermission(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_PERMISSIONS);
        setShowAddForm(false)
        toast.success('Permission added successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useCreatePermission